import { useAppKitAccount, useAppKitNetwork, useAppKitProvider } from '@reown/appkit/react'
import { Provider } from '@web3-react/types'
import { reownConnection } from 'connection'
import { ConnectionType } from 'connection/types'
import { useEffect } from 'react'
import { reownEip1193Provider } from 'reown/eip1193Provider'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { updateSelectedWallet } from 'state/user/reducer'

export default function ReownWeb3Bridge() {
  const dispatch = useAppDispatch()
  const selectedWallet = useAppSelector((state) => state.user.selectedWallet)
  const { address, isConnected } = useAppKitAccount({ namespace: 'eip155' })
  const { chainId } = useAppKitNetwork()
  const { walletProvider } = useAppKitProvider<Provider>('eip155')

  useEffect(() => {
    reownEip1193Provider.setProvider(walletProvider)

    if (!isConnected || !address || !walletProvider) {
      reownConnection.connector.resetState()
      if (selectedWallet === ConnectionType.REOWN) {
        dispatch(updateSelectedWallet({ wallet: undefined }))
      }
      return
    }

    let stale = false
    Promise.resolve(reownConnection.connector.activate())
      .then(() => {
        if (!stale) {
          dispatch(updateSelectedWallet({ wallet: ConnectionType.REOWN }))
        }
      })
      .catch((error: unknown) => {
        console.debug(`Reown web3-react bridge error: ${error}`)
      })

    return () => {
      stale = true
    }
  }, [address, chainId, dispatch, isConnected, selectedWallet, walletProvider])

  return null
}
